module.exports = __webpack_public_path__ + "static/img/about_active3.5df0bf7d.png";